export default __webpack_public_path__ + "static/media/bannerr2.eb6f5143.webp";